import React, {Component} from 'react';
import {withFirebase} from "../Firebase";
import Header from "../Header";
import {withAdmin} from "../Session/context";
import { FilePicker } from 'react-file-picker'
import Parser from '../../utils/parser.js'

class PageUpload extends Component {

    bannedPhrases = [".0f",".1f",".2f",".3f",".4f"];

    constructor(props) {
        super(props);
        this.state = {
            projects: [],
        }
    }

    componentDidMount() {
        this.props.firebase.getProjects().then(projects => {
            this.setState({
                projects: projects,
                selected: projects[0].id
            })
        });
    }

    changedProject = (event) => {
        this.setState({
            selected: event.target.value
        })
    };

    saveToDB = (strings) => {
        this.props.firebase.uploadFile(this.state.selected,strings);
    };

    containsBannedPhrase = (strings) => {
      let values = Object.values(strings);
      return values.some(string => {
          return this.bannedPhrases.some(banned => {
              return string.includes(banned);
          })
      })
    };

    upload = (file) => {
        const reader = new FileReader();

        // Closure to capture the file information.
        reader.onload = (e) => {
            const fileText = e.target.result;
            const parsed = Parser(fileText);
            if(!this.containsBannedPhrase(parsed)) {
                this.saveToDB(parsed);
            } else {
                alert("Contains banned string, rejecting upload! It's probably a decimal places modifier like .2f");
            }
        };

        reader.readAsText(file);
    };

    render() {

        if(!this.state.projects) return null;

        const options = this.state.projects.map(project => (<option key={project.id} value={project.id}>{project.title}</option>));

        return (
            <div>
                <Header title={`Upload`} subtitle={`Translations`} />
                <select value={this.state.selected} onChange={this.changedProject}>
                    {options}
                </select>
                <FilePicker
                    extensions={['xml']}
                    onChange={this.upload}>
                    <input type="button" value="Choose file to upload" />
                </FilePicker>
            </div>
        );
    }
}

export default withAdmin(withFirebase(PageUpload));